import {NumberGenerationRptConstants} from '../constants';

export function NumberGenerationRpt(state = {}, action) {   
    switch (action.type) {
        case NumberGenerationRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case NumberGenerationRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case NumberGenerationRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
            default:
                return state
        }
        
    }